import { TRIGGER_LOG_EVENT } from './action-types';

export function triggerLogEventAction(eventData) {
	return {
		type: TRIGGER_LOG_EVENT,
		eventData,
	};
}
